import React from 'react';
import { EditorProvider } from './store/EditorContext';
import { EditorLayout } from './components/EditorLayout';
import { FormDefinition } from './types';
import { Toaster } from 'react-hot-toast';

export interface PeakFormEditorProps {
    initialForm?: FormDefinition;
    onSave?: (form: FormDefinition) => void;
    onBack?: () => void;
}

export const PeakFormEditor: React.FC<PeakFormEditorProps> = ({ initialForm, onSave, onBack }) => {
    return (
        <EditorProvider initialForm={initialForm} onSave={onSave} onBack={onBack}>
            <div className="min-h-screen bg-gray-50 text-gray-900 font-sans">
                <EditorLayout />
                <Toaster position="bottom-right" />
            </div>
        </EditorProvider>
    );
};